import { useEffect } from "react";
import { ErrorBoundary } from "./components/GeneralErrorBoundry";
import { BalanceProvider } from "./context/balanceContext";
import { UserProvider } from "./context/userContext";
import { PendingActionsProvider } from "./context/pendingActionsContext";
import AppRoutes from "./routes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useAuth } from "./context/connectionContext";
import { logger } from "./lib/logger";
import { ErrorCodes } from "./lib/errorCodes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});

queryClient.getQueryCache().subscribe((event) => {
  if (event.type === "updated" && event.action.type === "error") {
    logger.error("api", ErrorCodes.API_001, "React Query error", event.action.error as Error, {
      queryKey: event.query.queryKey,
    });
  }
});

// This code is only for TypeScript
declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__: import("@tanstack/query-core").QueryClient;
  }
}

function WalletAddressSync() {
  const { account } = useAuth();
  useEffect(() => {
    logger.setWalletAddress(account ?? undefined);
  }, [account]);
  return null;
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <WalletAddressSync />
        <BalanceProvider>
          <PendingActionsProvider>
            <UserProvider>
              <AppRoutes />
            </UserProvider>
          </PendingActionsProvider>
        </BalanceProvider>
      </ErrorBoundary>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
